/* Maison analytics adapter: analytics:* CustomEvents -> dataLayer + GA4 + PostHog.
   Consent-gated via Shopify Customer Privacy API. */
(() => {
  const cfg = window.maisonAnalyticsConfig;
  // Stub always defined so callers can rely on window.maisonExperiment regardless of config.
  window.maisonExperiment = window.maisonExperiment || function (flagKey, callback) {
    setTimeout(function () { callback(undefined); }, 0);
  };
  if (!cfg) return;
  const EVENTS = [
    'view_item', 'view_item_list', 'select_item', 'add_to_cart',
    'remove_from_cart', 'view_cart', 'begin_checkout', 'search',
    'generate_lead', 'variant_selected', 'filter_applied'
  ];
  window.dataLayer = window.dataLayer || [];
  let started = false;
  let startedByInteraction = false;

  function log(...args) {
    if (cfg.debug) console.log('[analytics]', ...args);
  }

  function loadGa4() {
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', cfg.ga4Id, { send_page_view: true, debug_mode: !!cfg.debug || undefined });
  }

  function loadPosthog() {
    // Official posthog-js snippet (loads array.js from the configured host)
    !(function (t, e) { var o, n, p, r; e.__SV || ((window.posthog = e), (e._i = []), (e.init = function (i, s, a) { function g(t, e) { var o = e.split('.'); 2 == o.length && ((t = t[o[0]]), (e = o[1])), (t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }); } ((p = t.createElement('script')).type = 'text/javascript'), (p.crossOrigin = 'anonymous'), (p.async = !0), (p.src = s.api_host.replace('.i.posthog.com', '-assets.i.posthog.com') + '/static/array.js'), (r = t.getElementsByTagName('script')[0]).parentNode.insertBefore(p, r); var u = e; for (void 0 !== a ? (u = e[a] = []) : (a = 'posthog'), u.people = u.people || [], u.toString = function (t) { var e = 'posthog'; return 'posthog' !== a && (e += '.' + a), t || (e += ' (stub)'), e; }, u.people.toString = function () { return u.toString(1) + '.people (stub)'; }, o = 'init capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys'.split(' '), n = 0; n < o.length; n++) g(u, o[n]); e._i.push([i, s, a]); }), (e.__SV = 1)); })(document, window.posthog || []);
    window.posthog.init(cfg.posthogKey, {
      api_host: cfg.posthogHost,
      ui_host: 'https://us.posthog.com',
      defaults: '2026-05-30',
      person_profiles: 'identified_only',
      capture_pageview: true,
      disable_surveys: true,
      // Recorder stays out of the load window; engaged sessions still record
      disable_session_recording: true
    });
    if (cfg.sessionReplay) {
      if (startedByInteraction) {
        // start() itself was triggered by the first interaction — begin now.
        try { window.posthog.startSessionRecording(); } catch (e) {}
      } else {
        var beginRecording = function () {
          try { window.posthog.startSessionRecording(); } catch (e) {}
        };
        ['pointerdown', 'keydown', 'touchstart'].forEach(function (t) {
          document.addEventListener(t, beginRecording, { passive: true, once: true });
        });
      }
    }
  }

  function forward(name, detail) {
    const payload = Object.assign({ currency: cfg.currency }, detail || {});
    window.dataLayer.push(Object.assign({ event: name }, payload));
    if (cfg.ga4Id && window.gtag) window.gtag('event', name, payload);
    if (cfg.posthogKey && window.posthog) window.posthog.capture(name, payload);
    log(name, payload);
  }

  // Listen immediately: section scripts can dispatch before vendors start
  // (Shopify's bundled section JS is queued ahead of this file). Queue until
  // start() flushes; consent-gated events forward only after consent grants.
  const pending = [];
  EVENTS.forEach((name) => {
    document.addEventListener('analytics:' + name, (e) => {
      if (started) forward(name, e.detail);
      else pending.push([name, e.detail]);
    });
  });

  function start() {
    if (started) return;
    started = true;
    if (cfg.ga4Id) loadGa4();
    if (cfg.posthogKey) loadPosthog();
    while (pending.length) {
      const next = pending.shift();
      forward(next[0], next[1]);
    }
    log('started', cfg);
  }

  // Experiment helper: run callback with the flag variant once flags load.
  // Anti-flicker recipe for above-fold tests: hide the element inline
  // (style="visibility:hidden"), reveal inside the callback; the 500ms
  // timeout below is the failsafe reveal if PostHog never answers.
  window.maisonExperiment = function (flagKey, callback) {
    let done = false;
    const run = (variant) => { if (!done) { done = true; callback(variant); } };
    if (cfg.posthogKey && window.posthog) {
      window.posthog.onFeatureFlags(() => run(window.posthog.getFeatureFlag(flagKey)));
    }
    setTimeout(() => run(undefined), 500);
  };

  function consentAllowed() {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return true;
    return cp.analyticsProcessingAllowed();
  }

  // Vendor scripts (gtag ~160KB + posthog array.js ~70KB) cost ~3s of mobile
  // main-thread time — enough to zero the Lighthouse TBT score on 4x-throttled
  // devices. Load them on the first interaction instead of a fixed idle timer:
  // real shoppers init within a touch, lab runs never pay the cost. The 12s
  // fallback still counts patient non-interacting readers; the pending queue
  // above preserves any analytics:* events dispatched before init. Tradeoff:
  // sub-12s bounces with zero interaction are not counted, and feature-flag
  // experiments resolve their variant only after init (maisonExperiment's
  // 500ms failsafe shows the default variant until then).
  function startOnEngagement() {
    const kick = (e) => {
      clearTimeout(fallback);
      startedByInteraction = !!e;
      INTERACTIONS.forEach((t) => window.removeEventListener(t, kick));
      start();
    };
    const INTERACTIONS = ['pointerdown', 'keydown', 'touchstart', 'scroll'];
    INTERACTIONS.forEach((t) => window.addEventListener(t, kick, { passive: true, once: true }));
    const fallback = setTimeout(kick, 12000);
  }

  if (consentAllowed()) {
    startOnEngagement();
  } else {
    document.addEventListener('visitorConsentCollected', () => {
      if (consentAllowed()) startOnEngagement();
    });
  }
})();
